module.exports = __webpack_public_path__ + "img/logo-fine.4b1b5226.png";